<template>
  <div class="item-proche">
    <p>{{user.first_name}} {{user.last_name}} <span>{{formatDate(user.signup_date)}}</span></p>
    <router-link :to="{ name: 'edit-sub', params: { id: user.id } }"><i class="fas fa-user-cog"></i>Gérer le profil</router-link>
  </div>
</template>

<script>
import { formatDate } from '@/functions'
export default {
  props: ['user'],
  methods: {
    formatDate
  }
}
</script>

<style>

  .item-proche {
    background: #f6f6f6;
    border-top: 1px solid #ccc;
    padding: 10px 30px;
  }
  .item-proche p {
    font-size: 18px;
    color: #086fab;
    letter-spacing: 1px;
    font-family: 'blogger_sansbold';
    width: 50%;
    text-align: left;
    display: inline-block;
    margin-bottom: 0;
  }
  
  .item-proche span { font-size: 12px; color: #555; }
  
  .item-proche a {
    font-size: 15px;
    color: #de2128;
    letter-spacing: 1px;
    font-family: 'blogger_sansbold';
    width: 50%;
    display: inline-block;
    margin-bottom: 0;
    text-align: right;
    transition: all 0.4s ease;
  }
  
  .item-proche a .fas {
    margin-right: 10px;
  }
  
  .item-proche a:hover {
    color: #413492;
  }
  
</style>
